import React, { useEffect, useRef } from 'react';

const FrequencyVisualizer = ({ isActive = false }) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef?.current;
    if (!canvas) return;

    const ctx = canvas?.getContext('2d');
    const width = canvas?.width;
    const height = canvas?.height;

    const bars = 32;
    const barWidth = width / bars;
    const barHeights = Array(bars)?.fill(0)?.map(() => Math.random() * 0.3);

    const animate = () => {
      ctx?.clearRect(0, 0, width, height);

      barHeights?.forEach((currentHeight, index) => {
        const targetHeight = isActive 
          ? Math.random() * 0.8 + 0.2 
          : Math.random() * 0.3;
        
        barHeights[index] += (targetHeight - currentHeight) * 0.1;

        const barHeight = barHeights?.[index] * height;
        const x = index * barWidth;
        const y = height - barHeight;

        const gradient = ctx?.createLinearGradient(0, y, 0, height);
        gradient?.addColorStop(0, 'rgba(139, 115, 85, 0.6)');
        gradient?.addColorStop(1, 'rgba(139, 115, 85, 0.2)');

        ctx.fillStyle = gradient;
        ctx?.fillRect(x + 2, y, barWidth - 4, barHeight);
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef?.current) {
        cancelAnimationFrame(animationRef?.current);
      }
    };
  }, [isActive]);

  return (
    <canvas
      ref={canvasRef}
      width={400}
      height={80}
      className="frequency-visualizer w-full h-full opacity-50"
      aria-hidden="true"
    />
  );
};

export default FrequencyVisualizer;